export const version = "json-wallets/5.0.9";
//# sourceMappingURL=_version.js.map